import {useQuery} from "react-query"
import useAuth from "auth/useAuth"

export default function useRescuerLog(username) {

    const {auth, API} = useAuth()

    const query = useQuery(
        ["rescuer-log", username],
        () => auth(API.rescuersIdLogGet, {id: username}).then(response => response.data),
        {
            enabled: !!username,
            staleTime: 1000 * 60 * 5 // 5 minutes
        }
    )

    return query
}
